import React from 'react';
import { Card } from './ui/Card';
import { ProgressBar } from './ui/ProgressBar';
import { AlertTriangle, Users, PieChart } from 'lucide-react';
interface OwnershipSummaryProps {
  totalPercentage: number;
  primaryMemberCount: number;
}
export function OwnershipSummary({
  totalPercentage,
  primaryMemberCount
}: OwnershipSummaryProps) {
  const isOverLimit = totalPercentage > 100;
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-85">
      <Card className="flex flex-col justify-center" data-id="element-86">
        <div className="flex items-center gap-3 mb-2" data-id="element-87">
          <div className="p-2 bg-[#eef4ff] rounded text-[#0176d3]" data-id="element-88">
            <PieChart className="w-5 h-5" data-id="element-89" />
          </div>
          <h4 className="text-sm font-medium text-[#3e3e3c]" data-id="element-90">
            Total Ownership
          </h4>
        </div>
        <div className="mt-1" data-id="element-91">
          <div className="flex items-baseline gap-2 mb-2" data-id="element-92">
            <span className={`text-2xl font-bold ${isOverLimit ? 'text-[#ba0517]' : 'text-[#080707]'}`} data-id="element-93">
              {totalPercentage}%
            </span>
            <span className="text-xs text-[#706e6b]" data-id="element-94">of 100%</span>
          </div>
          <ProgressBar value={totalPercentage} data-id="element-95" />
          {isOverLimit && <div className="flex items-center gap-1 mt-2 text-xs text-[#ba0517]" data-id="element-96">
              <AlertTriangle className="w-3 h-3" data-id="element-97" />
              <span data-id="element-98">Exceeds 100% limit</span>
            </div>}
        </div>
      </Card>

      <Card className="flex flex-col justify-center" data-id="element-99">
        <div className="flex items-center gap-3 mb-2" data-id="element-100">
          <div className="p-2 bg-[#eef4ff] rounded text-[#0176d3]" data-id="element-101">
            <Users className="w-5 h-5" data-id="element-102" />
          </div>
          <h4 className="text-sm font-medium text-[#3e3e3c]" data-id="element-103">
            Primary Members
          </h4>
        </div>
        <div className="mt-1" data-id="element-104">
          <span className="text-2xl font-bold text-[#080707]" data-id="element-105">
            {primaryMemberCount}
          </span>
          <p className="text-xs text-[#706e6b] mt-1" data-id="element-106">
            Designated primary owners
          </p>
        </div>
      </Card>

      <Card className="flex flex-col justify-center bg-[#f3f2f2] border-dashed" data-id="element-107">
        <div className="text-center" data-id="element-108">
          <h4 className="text-sm font-medium text-[#3e3e3c] mb-1" data-id="element-109">Status</h4>
          {isOverLimit ? <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[#fe5c5c] text-white" data-id="element-110">
              Invalid Configuration
            </span> : totalPercentage === 100 ? <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[#04844b] text-white" data-id="element-111">
              Fully Allocated
            </span> : <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[#0176d3] text-white" data-id="element-112">
              Partially Allocated
            </span>}
          <p className="text-xs text-[#706e6b] mt-2" data-id="element-113">
            {isOverLimit ? 'Please adjust ownership percentages.' : `${100 - totalPercentage}% remaining for allocation.`}
          </p>
        </div>
      </Card>
    </div>;
}